/* Les voix du cacao · bandeau des fiches origine, v2.5 du 2026-10-13.
   Choisit le placement du bandeau (.mv2) dans chaque fiche :
   - aligned : dans la colonne des images, juste sous elles, à leur largeur ;
   - stack   : sous 900 px.
   Le placement large (au-dessus du Terroir) est retiré : il laissait un vide
   dès que la colonne n'avait plus 200 px de libre.
   Chargé SANS defer, juste après la fermeture de .moojo-origin__below-sheet : le premier
   placement a lieu avant l'affichage de la suite de la page.
   v2.3 : la photo est tirée au sort parmi les images du portail de la plateforme
   (script.mv2__photos), jamais la même deux fois de suite, et seulement parmi celles qui
   tiennent bien dans le cadre du moment (cadrage et définition).
   v2.4 : une image peut fixer l'origine du zoom de la colonne (zo) ou rester hors du téléphone
   (nomob) ; à l'heure data-voix-open-at, le bouton devient « Entrer » et la date disparaît. */
(function () {
  "use strict";

  if (window.__mv2Init) {
    if (window.__mv2PlaceAll) window.__mv2PlaceAll(true);
    return;
  }
  window.__mv2Init = true;

  var DESKTOP = window.matchMedia("(min-width: 900px)");

  function px(value) {
    var n = parseFloat(value);
    return isNaN(n) ? 0 : n;
  }

  function rootOf(sheet) {
    return sheet.closest(".moojo-origin") || document;
  }

  function slotOf(sheet) {
    return rootOf(sheet).querySelector(".mv2");
  }

  function setMode(sheet, slot, mode) {
    var column = sheet.querySelector(".moojo-origin__story-column");
    if (column && slot.parentNode !== column) column.appendChild(slot);
    if (slot.dataset.mode !== mode) slot.dataset.mode = mode;
  }

  function place(sheet) {
    var slot = slotOf(sheet);
    if (!slot) return;

    if (!DESKTOP.matches) {
      setMode(sheet, slot, "stack");
      return;
    }

    setMode(sheet, slot, "aligned");
  }

  /* ---------- Photo tirée au sort ---------- */

  var LAST_KEY = "mv2:last-photo";
  var SIZES = "(min-width: 1500px) 40vw, (min-width: 900px) 44vw, (min-width: 592px) 60vw, 100vw";
  var MIN_SHOWN = 0.4;   /* part minimale de l'image visible dans le sens recadré */
  var MAX_STRETCH = 1.3; /* agrandissement maximal accepté, écran haute définition compris */

  function readLast() {
    try { return window.sessionStorage.getItem(LAST_KEY) || ""; } catch (e) { return ""; }
  }

  function writeLast(id) {
    try { window.sessionStorage.setItem(LAST_KEY, id); } catch (e) { /* navigation privée : sans mémoire */ }
  }

  function photosOf(slot) {
    if (slot.__mv2Photos) return slot.__mv2Photos;
    var list = [];
    var data = slot.querySelector("script.mv2__photos");
    if (data) {
      try { list = JSON.parse(data.textContent) || []; } catch (e) { list = []; }
    }
    slot.__mv2Photos = list.filter(function (p) {
      return p && p.id && p.src && p.w > 0 && p.h > 0;
    });
    return slot.__mv2Photos;
  }

  function imageOf(slot) {
    var media = slot.querySelector(".mv2__media");
    if (!media) return null;
    var img = media.querySelector("img.mv2__img");
    if (!img) {
      img = document.createElement("img");
      img.className = "mv2__img";
      img.alt = "";
      img.decoding = "async";
      img.setAttribute("loading", "lazy");
      img.setAttribute("fetchpriority", "low");
      media.insertBefore(img, media.firstChild);
    }
    return img;
  }

  /* La photo tient-elle dans ce cadre : assez d'image visible, pas trop agrandie ? */
  function fits(p, box, zoom, phone) {
    var boxRatio = box.width / box.height;
    if (p.nomob && phone) return false; /* téléphone (photo en haut, texte dessous) : le sujet tomberait sous la date */
    var imgRatio = p.w / p.h;
    var shown = Math.min(boxRatio, imgRatio) / Math.max(boxRatio, imgRatio) / zoom;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var stretch = Math.max(box.width / p.w, box.height / p.h) * zoom * dpr;
    return shown >= MIN_SHOWN && stretch <= MAX_STRETCH;
  }

  function show(slot, img, p) {
    img.width = p.w;
    img.height = p.h;
    img.sizes = SIZES;
    if (p.srcset) img.srcset = p.srcset; else img.removeAttribute("srcset");
    img.src = p.src;
    slot.dataset.photo = p.id;
    slot.dataset.grade = p.grade || "nuit";
    if (p.pos) slot.style.setProperty("--mv2-pos", p.pos);
    if (p.pm) slot.style.setProperty("--mv2-pos-mobile", p.pm);
    if (p.zo) slot.style.setProperty("--mv2-origin-photo", p.zo);
    else slot.style.removeProperty("--mv2-origin-photo");
    var place = slot.querySelector(".mv2__credit-place");
    var by = slot.querySelector(".mv2__credit-by");
    if (place) place.textContent = p.place || "";
    if (by) {
      /* Crédit : chaque partie (auteur, licence) reste sur une ligne, la coupure se fait au point médian. */
      by.textContent = "";
      String(p.by || "").split(" · ").forEach(function (part, i) {
        if (i) by.appendChild(document.createTextNode(" · "));
        var bit = document.createElement("span");
        bit.textContent = part;
        if (part.length <= 24) bit.className = "mv2__nw"; /* licence courte : jamais coupée ; un long nom peut passer à la ligne */
        by.appendChild(bit);
      });
    }
    if ((p.place || p.by) && place && by) slot.setAttribute("data-credit", "");
    else slot.removeAttribute("data-credit");
  }

  function fillPorte(slot) {
    if (!slot || slot.__mv2Filled) return slot && slot.__mv2Door;
    var node = slot.querySelector("script.mv2__porte");
    if (!node) return null;
    var door;
    try { door = JSON.parse(node.textContent); } catch (e) { return null; }
    slot.__mv2Door = door;
    slot.__mv2Filled = true;
    var rom = slot.querySelector(".mv2__rom");
    var nom = slot.querySelector(".mv2__nom");
    var seuil = slot.querySelector(".mv2__seuil");
    if (rom) rom.textContent = door.rom ? door.rom + " ·" : "";
    if (nom) nom.textContent = door.nom || "";
    if (seuil) seuil.textContent = door.seuil || "";
    var card = slot.querySelector(".mv2__card");
    if (card) {
      var label = "▶ " + (door.verbe || "") + ". " + (door.oeuvre || "");
      if (door.an) label += " · " + door.an;
      card.setAttribute("data-cta-open", label);
    }
    return door;
  }

  function choosePhoto(slot) {
    if (!slot || !slot.dataset.mode || slot.dataset.mode === "none") return;
    if (slot.hasAttribute("data-porte")) {
      var door = fillPorte(slot);
      var img = imageOf(slot);
      if (door && img && door.u) {
        show(slot, img, {
          id: door.key,
          src: door.u,
          srcset: "",
          w: 1800,
          h: 1200,
          pos: door.pos || "50% 50%",
          pm: door.pos || "50% 50%",
          grade: "nuit",
          zo: "",
          place: door.cap || "",
          by: door.cr || ""
        });
      }
      return;
    }
    var list = photosOf(slot);
    if (!list.length) return;
    var media = slot.querySelector(".mv2__media");
    var img = imageOf(slot);
    if (!media || !img) return;
    var box = media.getBoundingClientRect();
    if (!box.width || !box.height) return;
    var zoom = px(window.getComputedStyle(img).getPropertyValue("--mv2-z")) || 1;
    var cardBox = (slot.querySelector(".mv2__card") || media).getBoundingClientRect();
    var phone = cardBox.height > 0 && cardBox.width / cardBox.height <= 1.2; /* même seuil que le CSS (aspect-ratio <= 6/5) */

    /* Bandeau re-rendu par le thème (variante, section) : garder la photo déjà montrée sur cette page. */
    if (!slot.dataset.photo && window.__mv2PagePhoto) {
      var kept = null;
      list.forEach(function (p) { if (p.id === window.__mv2PagePhoto) kept = p; });
      if (kept && fits(kept, box, zoom, phone)) { show(slot, img, kept); return; }
    }

    var current = slot.dataset.photo || "";
    var currentPhoto = null;
    list.forEach(function (p) { if (p.id === current) currentPhoto = p; });
    if (currentPhoto && (list.length === 1 || fits(currentPhoto, box, zoom, phone))) return;

    var pool = list.filter(function (p) { return fits(p, box, zoom, phone); });
    if (!pool.length) pool = list.slice();
    var last = readLast();
    var fresh = pool.filter(function (p) { return p.id !== last && p.id !== current; });
    if (fresh.length) pool = fresh;
    var pick = pool[Math.floor(Math.random() * pool.length)];
    show(slot, img, pick);
    writeLast(pick.id);
    window.__mv2PagePhoto = pick.id;
  }
  window.__mv2ChoosePhoto = choosePhoto;

  /* Ouverture : les pages sont en cache chez Shopify, la bascule se fait donc ici, à l'affichage.
     Le lien ne change pas (le même portail avant et après) ; seuls le bouton et la date changent. */
  var DAY = 864e5;

  function openCard(card) {
    var slot = card.closest(".mv2");
    if (!slot || slot.getAttribute("data-moment") === "open") return;
    var date = card.querySelector(".mv2__date");
    if (date && date.parentNode) date.parentNode.removeChild(date);
    var href = card.getAttribute("data-href-open");
    if (href) card.setAttribute("href", href);
    var cta = card.querySelector(".mv2__cta");
    var label = card.getAttribute("data-cta-open");
    if (cta && label) {
      cta.textContent = label;
      var tab = card.getAttribute("data-new-tab");
      if (tab) {
        var sr = document.createElement("span");
        sr.className = "mv2__sr";
        sr.textContent = " " + tab;
        cta.appendChild(sr);
      }
    }
    slot.setAttribute("data-moment", "open");
  }

  function checkOpen() {
    var now = Date.now();
    var next = Infinity;
    document.querySelectorAll(".mv2__card[data-voix-open-at]").forEach(function (card) {
      var at = Date.parse(card.getAttribute("data-voix-open-at") || "");
      if (isNaN(at)) return;
      if (now >= at) openCard(card);
      else if (at - now < next) next = at - now;
    });
    window.clearTimeout(checkOpen._t);
    if (next < DAY) {
      checkOpen._t = window.setTimeout(function () { placeAll(true); }, next + 500);
    }
  }

  var lastWidth = -1;
  var scheduled = false;

  function placeAll(force) {
    document.querySelectorAll(".mv2[data-porte]").forEach(fillPorte);
    checkOpen();
    var width = window.innerWidth;
    if (!force && width === lastWidth) return;
    lastWidth = width;
    document.querySelectorAll(".moojo-origin__sheet").forEach(function (sheet) {
      place(sheet);
      choosePhoto(slotOf(sheet));
    });
    observeAll();
  }
  window.__mv2PlaceAll = placeAll;

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      placeAll(true);
    });
  }

  /* Une image, une appli ou un accordéon qui change une hauteur relance le calcul. */
  var observer = window.ResizeObserver ? new ResizeObserver(schedule) : null;
  var watched = typeof WeakSet === "function" ? new WeakSet() : null;

  function watch(el) {
    if (!observer || !el || (watched && watched.has(el))) return;
    observer.observe(el, { box: "border-box" });
    if (watched) watched.add(el);
  }

  function observeAll() {
    if (!observer) return;
    document.querySelectorAll(".moojo-origin__sheet").forEach(function (sheet) {
      watch(sheet.querySelector(".moojo-origin__purchase"));
      watch(sheet.querySelector(".moojo-origin__commerce"));
      var column = sheet.querySelector(".moojo-origin__story-column");
      if (!column) return;
      Array.prototype.forEach.call(column.children, function (child) {
        if (!child.classList.contains("mv2")) watch(child);
      });
    });
  }

  /* Bouton d'accès avant l'ouverture : formulaire Klaviyo s'il est réglé, sinon l'inscription du pied de page. */
  document.addEventListener("click", function (event) {
    var link = event.target.closest && event.target.closest("a.mv2__card[data-voix-access]");
    if (!link) return;

    var formId = (link.getAttribute("data-klaviyo-form") || "").trim();
    if (formId && window.klaviyo) {
      event.preventDefault();
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(["openForm", formId]);
      return;
    }

    var target = document.querySelector('footer form[id^="newsletter-form"], .shopify-section--footer form[id^="newsletter-form"], form[id^="newsletter-form"][id*="footer"]') ||
      document.querySelector("footer, .shopify-section--footer");
    if (!target) return;
    event.preventDefault();
    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    target.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "center" });
    var email = target.querySelector && target.querySelector('input[type="email"]');
    if (email) window.setTimeout(function () { email.focus({ preventScroll: true }); }, reduce ? 0 : 450);
  });

  placeAll(true);
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () { placeAll(true); });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { placeAll(true); });
  }
  window.addEventListener("load", function () { placeAll(true); });
  window.addEventListener("resize", function () {
    window.clearTimeout(placeAll._t);
    placeAll._t = window.setTimeout(function () { placeAll(false); }, 120);
  });
  if (DESKTOP.addEventListener) DESKTOP.addEventListener("change", function () { placeAll(true); });
  ["product:rerender", "variant:change", "shopify:section:load"].forEach(function (name) {
    document.addEventListener(name, function () {
      window.setTimeout(function () { placeAll(true); }, 60);
    });
  });
})();
